class @App.Components.VideoSearchPagination
  constructor: ->
    @container = $('#video_search').find('.video-pagination')

    $(document).on 'App::Components::VideoSearch::search_submit', (e) =>
      @empty()

  empty: =>
    @container.html('')
